import { EventBus } from '@/event'

const releaseType = BUILDTYPE == 'PROD' ? 'prodv2' : 'betav1'
const releaseType1 = BUILDTYPE == 'PROD' ? 'prodv3' : 'betav1'

export const input = {
    state: {
        baseUrl: `https://vdrm.mobiotics.com/${releaseType}`,
        transUrl: `https://vtranscode.mobiotics.com/${releaseType}`,
        auth: `Bearer ${localStorage.getItem('token')}`,
        listAllJobTranscode: [],
        listFilteredJobTranscode: [],
        isTrancodeEnable: false,
        transcodeProcessName: '',
        allProfileList: []
    },
    getters: {
        getListAllJobTranscode: (state) => {
            return state.listAllJobTranscode;
        },
        getListFilteredJobTranscode: (state) => {
            return state.listFilteredJobTranscode;
        },
        getIsTrancodeEnable: (state) => {
            return state.isTrancodeEnable
        },
        getTranscodeProcessName: (state) => {
            return state.transcodeProcess
        },
        getAllProfileList: (state) => {
            return state.allProfileList;
        }
    },
    mutations: {
        setListAllJobTranscode: (state, data) => {
            state.listAllJobTranscode = data
        },
        setListFilteredJobTranscode: (state, data) => {
            if(data.filetype === "SCRUBBING"){ //only one scrubbing file can be selected
                let found = state.listFilteredJobTranscode.findIndex(ele => ele.filetype === "SCRUBBING")
                if(found === -1){
                    state.listFilteredJobTranscode.push(data)
                }else{
                    state.listFilteredJobTranscode.splice(found, 1, data)
                }
            }else{
                state.listFilteredJobTranscode = (data)
            }
        },
        setIsTrancodeEnable: (state, val) => {
            state.isTrancodeEnable = val
        },
        setTranscodeProcessName: (state, val) => {
            state.transcodeProcess = val
        },
        setAllProfileList: (state, val) => {
            state.allProfileList = val
        }
    },
    actions: {
        listPackagerFile(context, data) {
            let { filetype = "", filename = "", patternstring = "", page = "", pagesize = "", fromdate = "", todate = "" } = data
            EventBus.$emit('Loader', true)
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            // https://vdrm.mobiotics.com/betav1/packager/v1/files?filetype=SCRUBBING&pagesize=10&page=1
            if (filetype === 'SCRUBBING') {
                return new Promise(function(resolve, reject) {
                    fetch(`${context.getters.getbaseUrl1}/packager/v1/files?filetype=${filetype}&filename=${filename}&patternstring=${patternstring}&pagesize=${pagesize}&page=${page}&fromdate=${fromdate}&todate=${todate}`, {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                            }
                        })
                        .then(response => {
                            EventBus.$emit('Loader', false)
                            if (response.ok) {
                                resolve(response.json())
                            } else {
                                resolve(response.json())
                            }
                        }).catch(error => {
                            EventBus.$emit('Loader', false)
                            reject(error)
                        })
                })
            } else if (filetype === 'SUBTITLE') {
                return new Promise(function(resolve, reject) {
                    fetch(`${context.state.transUrl}/provider/v1/preprocess?preprocessstatus=SUCCESS&filetype=${filetype}&filename=${filename}&originalfilename=${patternstring}&pagesize=${pagesize}&page=${page}&fromdate=${fromdate}&todate=${todate}`, {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                            }
                        })
                        .then(response => {
                            EventBus.$emit('Loader', false)
                            if (response.ok) {
                                resolve(response.json())
                            } else {
                                resolve(response.json())
                            }
                        }).catch(error => {
                            EventBus.$emit('Loader', false)
                            reject(error)
                        })
                })
            } else {
                return new Promise(function(resolve, reject) {
                    fetch(`${context.state.baseUrl}/packager/v1/files?filetype=${filetype}&filename=${filename}&patternstring=${patternstring}&pagesize=${pagesize}&page=${page}&fromdate=${fromdate}&todate=${todate}`, {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                            }
                        })
                        .then(response => {
                            EventBus.$emit('Loader', false)
                            if (response.ok) {
                                resolve(response.json())
                            } else {
                                resolve(response.json())
                            }
                        }).catch(error => {
                            EventBus.$emit('Loader', false)
                            reject(error)
                        })
                })
            }
        },
        packageFiles(context, data) {
            EventBus.$emit('Loader', true)
            return new Promise(function(resolve, reject) {
                fetch(`${context.state.baseUrl}/provider/v1/syncfiles`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        },
                        method: 'POST',
                        body: data
                    })
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        },
        actInititedPackage(context, data) {
            EventBus.$emit('Loader', true)
            console.log('context', context);
            var myHeaders = new Headers();
            myHeaders.append("authorization", 'Bearer' + ' ' + localStorage.getItem('token'))
            let requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: data
            };
            return new Promise((resolve, reject) => {
                fetch(`${context.getters.getbaseUrl}/packager/v1/jobs`, requestOptions)
                    .then((response) => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/input.js